<fieldset class="ib-box-menu__section ib-box-menu__section--full">
    <legend class="u-hide-accessible">{{ 'MMB_CO2_INFO_TITLE' | translate }}</legend>
    <div>
        <section class="ib-layout__section">
            <div class="ib-box-cols">
                <div class="ib-box-cols__header">
                    <h3 class="ib-box-cols__title">{{ 'MMB_CO2_INFO_TITLE' | translate }}</h3>
                </div>
                <div>
                    <span
                        [innerHtml]="'MMB_CO2_INFO_SUBTITLE'| translate:{ kilosCo2Equivalent: model?.kilosCo2EquivalentFormatted }"
                        class="ib-box-cols__title-section u-mb-small ng-binding" style="display: inline-block;">
                    </span>
                    <div class="ib-text u-mb-small ib-text--inline ib-text--color-unfocused ng-binding">
                        <span
                        [innerHtml]="'MMB_CO2_INFO_BODY'|translate: { price: model?.priceFormatted } ">
                        </span>
                    </div>
                </div>
                <div class="ib-box-cols__header u-mt-medium"></div>
                <div class="ng-scope">
                    <button type="button" class="ib-link ib-link--inline u-mb-small ng-binding" (click)="navigateCO2Modal()">
                        {{ 'MMB_CO2_INFO_LINK_TEXT' | translate }}
                    </button>
                    <span
                        class="ib-summary-breakdown__icon ib-summary-breakdown__icon--absolute ib-summary-breakdown__icon--carbon-footprint icon-carbon_footprint u-mb-small ib-text--inline ng-binding"
                        style="position: relative; left: 1px;">
                    </span>
                </div>
            </div>
        </section>
    </div>
</fieldset>
